import * as types from './examMetricsActionType';

export const fetchExamMetricsMatrixRequest = (payload) => ({
	type: types.FETCH_EXAM_METRICS_MATRIX_REQUEST,
	payload
});

export const fetchExamMetricsMatrixSuccess = (payload) => ({
	type: types.FETCH_EXAM_METRICS_MATRIX_SUCCESS,
	payload
});

export const fetchExamMetricsMatrixFailure = (payload) => ({
	type: types.FETCH_EXAM_METRICS_MATRIX_FAILURE,
	payload
});

export const fetchExamMetricsDropdownRequest = () => ({
	type: types.FETCH_EXAM_METRICS_DROPDOWN_REQUEST
});

export const fetchExamMetricsDropdownSuccess = (payload) => ({
	type: types.FETCH_EXAM_METRICS_DROPDOWN_SUCCESS,
	payload
});

export const fetchExamMetricsDropdownFailure = (payload) => ({
	type: types.FETCH_EXAM_METRICS_DROPDOWN_FAILURE,
	payload
});

export const fetchExamMetricsDateRangeRequest = () => ({
	type: types.FETCH_EXAM_METRICS_DATE_RANGE_REQUEST
});

export const fetchExamMetricsDateRangeSuccess = (payload) => ({
	type: types.FETCH_EXAM_METRICS_DATE_RANGE_SUCCESS,
	payload
});

export const fetchExamMetricsDateRangeFailure = (payload) => ({
	type: types.FETCH_EXAM_METRICS_DATE_RANGE_FAILURE,
	payload
});
